export default "__VITE_ASSET__DhU5RQZS__"